// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"025d2c0b","696":"90cb31af"}[chunkId] + ".chunk.css";
};